export enum ExclusivityStatus {
  Internal = 1,
  External,
}
